import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { api } from "../lib/config";

const STORAGE_KEY = "pv_announcement_dismissed_v1";

const Announcement = () => {
  const [data, setData] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/content/site_announcement");
        const v = r.data?.value;
        if (v?.enabled && !sessionStorage.getItem(STORAGE_KEY)) {
          setData(v);
          // Slight delay for elegance
          setTimeout(() => setShow(true), 800);
        }
      } catch {}
    })();
  }, []);

  const close = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setShow(false);
  };

  if (!data) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[80] bg-[#171717]/85 backdrop-blur-sm flex items-center justify-center p-6"
          onClick={close}
          data-testid="site-announcement"
        >
          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.96 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            onClick={(e) => e.stopPropagation()}
            className="relative max-w-lg w-full bg-[#171717] border border-[#9A8640]/50 p-10 sm:p-12 text-center"
          >
            <button
              onClick={close}
              className="absolute top-4 right-4 text-[#DDD4B2]/60 hover:text-[#9A8640] transition-colors"
              aria-label="Fermer"
              data-testid="announcement-close"
            >
              <X size={20} />
            </button>
            <div className="flex items-center justify-center gap-3 text-[#9A8640] mb-5">
              <span className="h-px w-10 bg-[#9A8640]/60" />
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z" fill="currentColor" opacity="0.85"/>
              </svg>
              <span className="h-px w-10 bg-[#9A8640]/60" />
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl text-white mb-5 leading-tight" data-testid="announcement-title">
              {data.title}
            </h2>
            <p className="text-[#DDD4B2]/85 leading-relaxed mb-8 whitespace-pre-line" data-testid="announcement-message">
              {data.message}
            </p>
            <button onClick={close} className="btn-gold px-8 py-3 text-xs uppercase tracking-[0.18em]" data-testid="announcement-cta">
              {data.cta_text || "J'ai compris"}
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Announcement;
